import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Text } from "~/components-shared";
const Wrapper = styled.div`
  width: 100%;
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  border-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};
`;
const TabHeader = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(${_ref3 => {
  let {
    $count
  } = _ref3;
  return $count;
}}, minmax(0, 1fr));
  border-bottom: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.grey.dark;
}};
  background-color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.grey.dark;
}};
  border-top-right-radius: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.shape.borderRadius.primary;
}};
  border-top-left-radius: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.shape.borderRadius.primary;
}};
`;
const TabItem = styled.button`
  width: 100%;
  display: flex;
  padding: 0;
  height: 40px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  position: relative;
  border-top-right-radius: ${_ref8 => {
  let {
    theme
  } = _ref8;
  return theme.shape.borderRadius.primary;
}};
  border-top-left-radius: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.shape.borderRadius.primary;
}};
  background-color: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.grey.dark;
}};

  ${_ref11 => {
  let {
    $isActive,
    theme
  } = _ref11;
  return $isActive && `
    border-width: 1px 1px 0;
    background-color: ${theme.colors.background.primary};
    border-style: solid;
    border-color: ${theme.colors.grey.dark};
    border-top-right-radius: ${theme.shape.borderRadius.primary};
    border-top-left-radius: ${theme.shape.borderRadius.primary};
    &:after {
      content: "";
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: ${theme.colors.background.primary};
    }
  `;
}}

  ${_ref12 => {
  let {
    $isFilled,
    theme
  } = _ref12;
  return $isFilled && `
    &:before {
      content: "";
      position: absolute;
      bottom: -5px;
      left: calc(50% - 4px);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.colors.success.main};
      border: 2px solid ${theme.colors.background.primary};
      z-index: 1;
    }
  `;
}}
`;
const TabContent = styled.div`
  padding: 1rem;
  border-width: 0 1px 1px;
  border-style: solid;
  border-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.grey.dark;
}};
  background-color: ${_ref14 => {
  let {
    theme
  } = _ref14;
  return theme.colors.background.primary;
}};
  border-bottom-right-radius: ${_ref15 => {
  let {
    theme
  } = _ref15;
  return theme.shape.borderRadius.primary;
}};
  border-bottom-left-radius: ${_ref16 => {
  let {
    theme
  } = _ref16;
  return theme.shape.borderRadius.primary;
}};
`;
const TabContentItem = styled.div`
  &.hidden {
    display: none;
  }
`;
const Tabs = _ref17 => {
  let {
    active,
    items = [],
    onChange,
    children,
    s = {}
  } = _ref17;
  const [tab, setTab] = useState(active || items[0].id);
  useEffect(() => {
    if (active) {
      setTab(active);
    }
  }, [active]);
  const handleClick = id => {
    setTab(id);
    if (onChange && typeof onChange === "function") {
      onChange(id);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    $s: s
  }, /*#__PURE__*/React.createElement(TabHeader, {
    $count: items.length
  }, items.map(item => /*#__PURE__*/React.createElement(TabItem, {
    key: item.title,
    onClick: () => handleClick(item.id),
    $isActive: item.id === tab,
    $isFilled: false,
    type: "button"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, item.title)))), /*#__PURE__*/React.createElement(TabContent, null, items.map(item => /*#__PURE__*/React.createElement(TabContentItem, {
    key: item.id,
    className: item.id !== tab ? "hidden" : ""
  }, children(item.id)))));
};
export default Tabs;